import {
  Button,
  Modal,
  Form,
  Input,
  Flex,
  Typography,
  message,
} from "antd";
import React, { forwardRef, useState, useImperativeHandle } from "react";
import { EditOutlined } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";

const UpdateModal = forwardRef((props, ref) => {
  const [form] = Form.useForm();
  const { record: updateModalRef, onSuccess } = props;
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  useImperativeHandle(ref, () => ({
    showModal: async (record) => {
      try {
        setVisible(true);
        setLoading(true);
        console.log(record);
        // 回显值
        form.setFieldsValue({
          roleId: record.roleId,
          roleName: record.roleName,
          remark: record.remark,
        });
      } catch (error) {
        message.error("Failed to fetch user data");
      } finally {
        setLoading(false);
      }
    },
  }));

  const onFinish = async (values) => {
    try {
      setLoading(true);
      console.log("modal.values:", values);

      const queryParams = {
        roleId: values.roleId,
        roleName: values.roleName,
        remark: values.remark,
      };
      const response = await http.post(`${api.getUpdateRole}`, queryParams);
      if (response.code === "1") {
        message.success("Password modified successfully.");
        setVisible(false);
        onSuccess?.();
      } else {
        message.error(response.msg);
      }
    } catch (error) {
      message.error("Password modification failed.");
    } finally {
      setLoading(false);
    }
  };

  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };

  return (
    <Modal
      title={
        <Flex justify="flex-start" align="flex-start" className="model_title">
          <EditOutlined className="model_title_mr10" />
          <Typography.Title level={4} className="mg">
            UPDATE ROLE
          </Typography.Title>
        </Flex>
      }
      width="50%"
      open={visible}
      onCancel={() => {
        setVisible(false);
        form.resetFields(); 
      }}
      footer={
         <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
        <Button
          key="back"
          onClick={() => {
            setVisible(false);
            form.resetFields();
          }}
        >
          Cancel
        </Button>
        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={() => form.submit()}
        >
          Submit
        </Button>
      </div>}
    >
      <Flex justify="space-between" align="flex-start">
        <div className="model_top" style={{ width: "100%" }}>
          <div className="model_content">
            <Form
              {...layout}
              name="passwordResetForm"
              onFinish={onFinish}
              form={form}
              labelCol={{
                style: {
                  width: "150px",
                },
              }}
              wrapperCol={{
                style: {
                  flex: 1,
                },
              }}
            >
              <Form.Item
                name="roleName"
                label="Role Name"
                rules={[
                  {
                    required: true,
                    message: "Please enter Role Name.",
                  },
                ]}
              >
                <Input placeholder="Please enter Role Name." allowClear />
              </Form.Item>

              <Form.Item name="remark" label="Remark">
                <Input placeholder="Please enter remark." allowClear />
              </Form.Item>

              <Form.Item name="roleId" noStyle>
                <Input type="hidden" />
              </Form.Item>
            </Form>
          </div>
        </div>
      </Flex>
    </Modal>
  );
});

export default UpdateModal;
